<p class="onboarding-welcome">
    {{ 'modals.resume_incomplete_store_setup.welcome' | translate:{ name: userName } }}
</p>

<div class="onboarding-layout">
    <div class="onboarding-copy">
        <section class="text-card description-card">
            <p class="text-center">{{ 'modals.resume_incomplete_store_setup.description' | translate }}</p>
        </section>
    </div>
</div>

<div class="cta-row">
    <button mat-flat-button color="primary" (click)="onContinue()">
        {{ 'modals.resume_incomplete_store_setup.button' | translate }}
    </button>
</div>
